/**
 * Custom hook per ottenere l'ID utente (sub) dall'utente autenticato tramite OIDC.
 * @returns {string | undefined} L'identificativo univoco dell'utente (sub) oppure undefined se non autenticato.
 */
import { useAuth } from "react-oidc-context";

export function useUserId() {
  const { user } = useAuth();
  return user?.profile.sub
}
